import {
  useContext,
  useState,
  createContext,
  ReactNode,
  useEffect,
} from "react";

interface TableContextState {
  disabled: boolean;
  working: boolean;
  showSkeleton: boolean;
  onOpenMonitorDetail?: (monitorId: UUID, issueId?: UUID) => void;
}

type SetTableContextState = (
  nextState:
    | TableContextState
    | ((prevState: TableContextState) => TableContextState)
) => void;

const TableCtx = createContext<
  [TableContextState, SetTableContextState] | null
>(null);

export default function GlobalTableStateProvider({
  children,
  disabled = false,
  working = false,
  showSkeleton = false,
  onOpenMonitorDetail,
}: { children: ReactNode } & Partial<TableContextState>) {
  const [state, setState] = useState<TableContextState>({
    disabled,
    working,
    showSkeleton,
    onOpenMonitorDetail,
  });

  useEffect(() => {
    setState((prevState) => ({ ...prevState, onOpenMonitorDetail }));
  }, [onOpenMonitorDetail]);

  return (
    <TableCtx.Provider value={[state, setState]}>{children}</TableCtx.Provider>
  );
}

export const useGlobalTableState = () => {
  const ctx = useContext(TableCtx);
  if (!ctx)
    throw new Error(
      "useGlobalTableState must be used within a GlobalTableStateProvider"
    );

  return ctx;
};
